import { ImageMagick, MagickFormat, initializeImageMagick } from '@imagemagick/magick-wasm';

const PUZZLE_VIDE0 = {
  PREVIEW_PLACEHOLDER: {
    WIDTH: 1024,
    HEIGHT: 1024,
    QUALITY: 95,
  },
  ICON: {
    WIDTH: 256,
    HEIGHT: 256,
    QUALITY: 90,
  },
};

type ImageVersion = { file: File; width: number; height: number };
type StaticAssetVersions = {
  iconVersion: ImageVersion;
  previewPlaceholderVersion: ImageVersion;
};

export const generateStaticAssets = async (file: File): Promise<StaticAssetVersions> => {
  const wasmLocation = new URL('@imagemagick/magick-wasm/magick.wasm', import.meta.url);
  const config = await (await fetch(wasmLocation.toString())).arrayBuffer();
  await initializeImageMagick(config);

  const fileArrayBuffer = new Uint8Array(await file.arrayBuffer());
  return await ImageMagick.read(fileArrayBuffer, async (baseImage) => {
    const imageProcessPromises = [PUZZLE_VIDE0.PREVIEW_PLACEHOLDER, PUZZLE_VIDE0.ICON].map(
      async (RESOLUTION) => {
        if (!RESOLUTION) return null;

        return new Promise((resolve, reject) => {
          baseImage.clone(async (baseCloned) => {
            try {
              baseCloned.resize(RESOLUTION.WIDTH, RESOLUTION.HEIGHT);
              baseCloned.write(MagickFormat.Jpeg, (data) => {
                resolve({
                  file: new File(
                    [data],
                    `${file.name.split('.').slice(0, -1).join('.')}_${RESOLUTION.WIDTH}_${
                      RESOLUTION.HEIGHT
                    }.${file.name.split('.').at(-1)}`,
                    { type: file.type },
                  ),
                  width: RESOLUTION.WIDTH,
                  height: RESOLUTION.HEIGHT,
                });
              });
            } catch (err) {
              reject(err);
            }
          });
        });
      },
    );

    const [previewFile, iconFile] = await Promise.all(imageProcessPromises);

    return {
      iconVersion: iconFile as ImageVersion,
      previewPlaceholderVersion: previewFile as ImageVersion,
    } as StaticAssetVersions;
  });
};
